/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_Automated_AssistanceInputs */

const en_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable automated assistance`)
};

const es_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar asistencia automatizada`)
};

const fr_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'assistance automatisée`)
};

const de_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierte Assistenz aktivieren`)
};

const ja_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動アシスタンスを有効にする`)
};

const zh_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用自动化助手`)
};

const ar_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفعيل المساعدة الآلية`)
};

const id_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan bantuan otomatis`)
};

const it_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita assistenza automatizzata`)
};

const ru_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить автоматическую помощь`)
};

const pt_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar assistência automatizada`)
};

const ko_enable_automated_assistance = /** @type {(inputs: Enable_Automated_AssistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동 지원 활성화`)
};

/**
* | output |
* | --- |
* | "Enable automated assistance" |
*
* @param {Enable_Automated_AssistanceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_automated_assistance = /** @type {((inputs?: Enable_Automated_AssistanceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Automated_AssistanceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_automated_assistance(inputs)
	if (locale === "es") return es_enable_automated_assistance(inputs)
	if (locale === "fr") return fr_enable_automated_assistance(inputs)
	if (locale === "de") return de_enable_automated_assistance(inputs)
	if (locale === "ja") return ja_enable_automated_assistance(inputs)
	if (locale === "zh") return zh_enable_automated_assistance(inputs)
	if (locale === "ar") return ar_enable_automated_assistance(inputs)
	if (locale === "id") return id_enable_automated_assistance(inputs)
	if (locale === "it") return it_enable_automated_assistance(inputs)
	if (locale === "ru") return ru_enable_automated_assistance(inputs)
	if (locale === "pt") return pt_enable_automated_assistance(inputs)
	return ko_enable_automated_assistance(inputs)
});